export default __webpack_public_path__ + "static/us-consumer-product-faq-bg-large-40438ec96fbdcc0472a9e6a0bf380c82.jpg";